module.exports = __webpack_public_path__ + "img/login-image.93069423.svg";